import { API_URL } from '../config';
import { Video } from '../types/video';
import { axios } from '../utils/custom-axios';

import type { Response } from '../types/response';

type GetAllVideoArgument = {
  name?: string;
  subject?: string;
  chapter?: string;
};
type GetAllVideoReturnType = {
  total: number;
  result: Video[];
};
const getAll = (query: GetAllVideoArgument, admin = false) => {
  const queryString = `${API_URL}${admin ? 'admin/' : ''}video?pagination=false\
${query.name ? `&name=${query.name}` : ''}
${query.subject ? `&subject=${query.subject}` : ''}
${query.chapter ? `&chapter=${query.chapter}` : ''}`;

  return axios.get<Response<GetAllVideoReturnType>>(queryString);
};

type GetAllVideoPaginatedArgument = {
  name?: string;
  subject?: string;
  chapter?: string;
  pageNumber?: number;
  pageSize?: number;
};
type EditArgument = {
  name?: string;
  subject?: string;
  chapter?: string;
  description?: string;
};
type GetAllVideoPaginatedReturnType = {
  total: number;
  pageSize: number;
  pageCount: number;
  result: Video[];
};
const getAllPaginated = (query: GetAllVideoPaginatedArgument, admin = false) => {
  const queryString = `${API_URL}${admin ? 'admin/' : ''}video?pagination=true\
${query.name ? `&name=${query.name}` : ''}\
${query.subject ? `&subject=${query.subject}` : ''}\
${query.chapter ? `&chapter=${query.chapter}` : ''}\
${query.pageNumber !== undefined ? `&pageNumber=${query.pageNumber}` : ''}\
${query.pageSize !== undefined ? `&pageSize=${query.pageSize}` : ''}`;

  return axios.get<Response<GetAllVideoPaginatedReturnType>>(queryString);
};

const getById = (videoId: string, admin = false) => {
  const queryString = `${API_URL}${admin ? 'admin/' : ''}video/${videoId}`;

  return axios.get<Response<Video>>(queryString);
};

const edit = (videoId: string, queryBody: EditArgument, admin = false) => {
  const queryString = `${API_URL}${admin ? 'admin/' : ''}video/${videoId}`;

  return axios.patch<Response<Video>>(queryString, queryBody);
};
const create = (data: {}) => {
  return axios.post<Response<Video>>(`${API_URL}admin/video`, data);
};

const deleteById = (videoId: string) => {
  return axios.delete(`${API_URL}admin/video/${videoId}`);
};

const createUploadToken = (fileName: string) => {
  return axios.post(`${API_URL}admin/video/upload/token`, { fileName });
};

const VideoService = {
  getAll,
  getAllPaginated,
  getById,
  edit,
  create,
  deleteById,
  createUploadToken,
};
export default VideoService;
